import React, { useEffect, useState } from 'react'
import UILoader from '@bufferapp/ui/Loader'

import { Wrapper } from './Loader.styles'

/**
 *
 */
const Loader = ({ delay = 0 }) => {
  const [show, setShow] = useState(false)
  const [timer, setTimer] = useState(null)

  useEffect(() => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    setTimer(setTimeout(() => setShow(true), delay))

    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    return () => clearTimeout(timer)
  }, [])

  return <Wrapper>{show && <UILoader />}</Wrapper>
}

export default Loader
